import { Role } from '../../services/dtos/role';

export class FetchAllRoles {
    public static readonly type = '[AdminRoles] Fetch All Roles';
}

export class FetchAllRightsIfEmpty {
    public static readonly type = '[AdminRoles] Fetch All Rights';
}

export class UpdateRole {
    public static readonly type = '[AdminRoles] Update';
    public constructor(public payload: Role) { }
}

export class DeleteRole {
    public static readonly type = '[AdminRoles] Delete';
    public constructor(public id: string) { }
}

export class AddRole {
    public static readonly type = '[AdminRoles] Add';
    public constructor(public payload: Role) { }
}
